









import { Prop, Component, Vue } from 'vue-property-decorator'
import { sanitizeEmailTemplateForEditor } from '@/helpers/html'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

// @ts-ignore
import VueQuillEditor from 'vue-quill-editor'
Vue.use(VueQuillEditor)

@Component
export default class InputRichTextEditor extends Vue {
    @Prop({ required: true }) content!: string
    emittedHtml: string = null

    onEditorChange({ html }) {
        this.emittedHtml = html
        this.$emit('input', html)
    }

    /**
     * Quill parses what it gets in the page (an <img onerror> would run), so a stored template is sanitized
     * first. The editor's own output comes back unchanged: sanitizing it again would reload the editor on every
     * keystroke.
     */
    get editorContent(): string {
        if (this.content === this.emittedHtml) {
            return this.content
        }

        return sanitizeEmailTemplateForEditor(this.content)
    }

    get options() {
        return {
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ header: 1 }, { header: 2 }],
                    [{ list: 'ordered'}, { list: 'bullet' }],
                    [{ align: [] }],
                    [{ color: [] }],
                    ['link', 'image'],
                    ['clean'],
                ],
            },
        }
    }
}
